export default "__VITE_ASSET__CEIeZwdS__"